module.exports = __webpack_public_path__ + "static/media/fbe-topographic-pattern-black12.dc4ee988.svg";